import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation } from 'swiper/modules';

export default class PartinershipsItemSlider {
    constructor() {
        this.slider = document.querySelector('.swiper--component-partnerships-slider');
        this.navigationPrev = document.querySelector('.slider-button-prev--component-partnerships-slider');
        this.navigationNext = document.querySelector('.slider-button-next--component-partnerships-slider');

        this.ready();
    }

    ready() {
        const swiper = new Swiper(this.slider, {
            modules: [Navigation],
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 24,
            allowTouchMove: true,
            autoHeight: true, //enable auto height
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            breakpoints: {
                640: {
                    slidesPerView: 1,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 1,
                    spaceBetween: 24,
                },
                2000: {
                    slidesPerView: 1,
                },
                2400: {
                    slidesPerView: 1,
                },
            },
        });
    }
}

if (document.querySelector('.swiper--component-partnerships-slider')) {
    new PartinershipsItemSlider();
}
